var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxTopLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "box-top-left_svg__box-top-left",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 339 339",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".box-top-left_svg__st2{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "box-top-left_svg__SVGID_1_",
    d: "M-21.1-26.5h361v393h-361z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "box-top-left_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#box-top-left_svg__SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#box-top-left_svg__SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "box-top-left_svg__st2",
    d: "M1.3 300.6c0 20.5 16.6 37.1 37.1 37.1h261.2c20.5 0 37.1-16.6 37.1-37.1V39.4c0-20.5-16.6-37.1-37.1-37.1H38.4C17.9 2.3 1.3 18.9 1.3 39.4v261.2z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "box-top-left_svg__st2",
    d: "M229.3 156.2h34.2v131.1h-34.2zM178 47.1h34.2v240.1H178zM126.8 102.4H161v184.8h-34.2zM75.6 47.1h34.2v240.1H75.6z"
  })));
}
export default __webpack_public_path__ + "100003155e9feb7a0d8c5febe35c8996.svg";
export { SvgBoxTopLeft as ReactComponent };